!function (t, e) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = e(require("react"), require("classnames"));else if ("function" == typeof define && define.amd) define(["react", "classnames"], e);else {
    var n = "object" == typeof exports ? e(require("react"), require("classnames")) : e(t.react, t.classnames);

    for (var i in n) {
      ("object" == typeof exports ? exports : t)[i] = n[i];
    }
  }
}("undefined" != typeof self ? self : this, function (t, e) {
  return function (t) {
    var e = {};

    function n(i) {
      if (e[i]) return e[i].exports;
      var a = e[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return t[i].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, i) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: i
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var i = Object.create(null);
      if (n.r(i), Object.defineProperty(i, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var a in t) {
        n.d(i, a, function (e) {
          return t[e];
        }.bind(null, a));
      }
      return i;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 107);
  }({
    0: function _(e, n) {
      e.exports = t;
    },
    1: function _(t, n) {
      t.exports = e;
    },
    107: function _(t, e, n) {
      "use strict";

      var _i,
          a = this && this.__extends || (_i = function i(t, e) {
        return (_i = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(t, e);
      }, function (t, e) {
        function n() {
          this.constructor = t;
        }

        _i(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
      }),
          r = this && this.__assign || function () {
        return (r = Object.assign || function (t) {
          for (var e, n = 1, i = arguments.length; n < i; n++) {
            for (var a in e = arguments[n]) {
              Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
            }
          }

          return t;
        }).apply(this, arguments);
      },
          o = this && this.__rest || function (t, e) {
        var n = {};

        for (var i in t) {
          Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
        }

        if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
          var a = 0;

          for (i = Object.getOwnPropertySymbols(t); a < i.length; a++) {
            e.indexOf(i[a]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[a]) && (n[i[a]] = t[i[a]]);
          }
        }

        return n;
      },
          s = this && this.__importDefault || function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var u = s(n(0)),
          c = s(n(1)),
          d = n(155),
          p = n(38),
          l = n(108);

      e.withRipple = function (t) {
        var e;
        return (e = function (e) {
          function n() {
            var n = null !== e && e.apply(this, arguments) || this;
            return n.isComponentMounted = !0, n.isTouched = !1, n.displayName = "WithRipple(" + function (t) {
              return t.displayName || t.name || "Component";
            }(t) + ")", n.state = {
              classList: new Set(),
              style: {}
            }, n.initializeFoundation = function (t, e) {
              var i = n.createAdapter(t, e);
              n.foundation = new d.MDCRippleFoundation(i), n.foundation.init();
            }, n.createAdapter = function (t, e) {
              return {
                browserSupportsCssVars: function browserSupportsCssVars() {
                  return p.supportsCssVariables(window);
                },
                isUnbounded: function isUnbounded() {
                  return n.props.unbounded;
                },
                isSurfaceActive: function isSurfaceActive() {
                  return e ? l.matches(e, ":active") : l.matches(t, ":active");
                },
                isSurfaceDisabled: function isSurfaceDisabled() {
                  return n.props.disabled;
                },
                addClass: function addClass(t) {
                  n.isComponentMounted && n.setState({
                    classList: n.state.classList.add(t)
                  });
                },
                removeClass: function removeClass(t) {
                  if (n.isComponentMounted) {
                    var e = n.state.classList;
                    e.delete(t), n.setState({
                      classList: e
                    });
                  }
                },
                registerDocumentInteractionHandler: function registerDocumentInteractionHandler(t, e) {
                  return document.documentElement.addEventListener(t, e, p.applyPassive());
                },
                deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler(t, e) {
                  return document.documentElement.removeEventListener(t, e, p.applyPassive());
                },
                registerResizeHandler: function registerResizeHandler(t) {
                  return window.addEventListener("resize", t);
                },
                deregisterResizeHandler: function deregisterResizeHandler(t) {
                  return window.removeEventListener("resize", t);
                },
                updateCssVariable: n.updateCssVariable,
                computeBoundingRect: function computeBoundingRect() {
                  return n.isComponentMounted ? n.props.computeBoundingRect ? n.props.computeBoundingRect(t) : t.getBoundingClientRect() : {
                    bottom: 0,
                    height: 0,
                    left: 0,
                    right: 0,
                    top: 0,
                    width: 0,
                    x: 0,
                    y: 0
                  };
                },
                containsEventTarget: function containsEventTarget(t) {
                  return !(!e || null === t) && e.contains(t);
                },
                registerInteractionHandler: function registerInteractionHandler() {
                  return null;
                },
                deregisterInteractionHandler: function deregisterInteractionHandler() {
                  return null;
                },
                getWindowPageOffset: function getWindowPageOffset() {
                  return {
                    x: window.pageXOffset,
                    y: window.pageYOffset
                  };
                }
              };
            }, n.handleFocus = function (t) {
              n.props.onFocus && n.props.onFocus(t), n.foundation.handleFocus();
            }, n.handleBlur = function (t) {
              n.props.onBlur && n.props.onBlur(t), n.foundation.handleBlur();
            }, n.handleMouseDown = function (t) {
              n.props.onMouseDown && n.props.onMouseDown(t), n.isTouched ? n.isTouched = !1 : n.activateRipple(t);
            }, n.handleMouseUp = function (t) {
              n.props.onMouseUp && n.props.onMouseUp(t), n.deactivateRipple();
            }, n.handleTouchStart = function (t) {
              n.isTouched = !0, n.props.onTouchStart && n.props.onTouchStart(t), n.activateRipple(t);
            }, n.handleTouchEnd = function (t) {
              n.props.onTouchEnd && n.props.onTouchEnd(t), n.deactivateRipple();
            }, n.handleKeyDown = function (t) {
              n.props.onKeyDown && n.props.onKeyDown(t), n.activateRipple(t);
            }, n.handleKeyUp = function (t) {
              n.props.onKeyUp && n.props.onKeyUp(t), n.deactivateRipple();
            }, n.activateRipple = function (t) {
              t.persist(), n.foundation.activate(t.nativeEvent);
            }, n.deactivateRipple = function () {
              n.foundation.deactivate();
            }, n.updateCssVariable = function (t, e) {
              n.isComponentMounted && n.setState(function (i) {
                var a = Object.assign({}, n.state.style, i.style);
                return null === e ? delete a[t] : a[t] = e, Object.assign(i, {
                  style: a
                });
              });
            }, n;
          }

          return a(n, e), n.prototype.componentDidMount = function () {
            if (!this.foundation) throw new Error("You must call initRipple from the element's ref prop to initialize the adapter for withRipple");
          }, n.prototype.componentDidUpdate = function (t) {
            this.props.disabled !== t.disabled && this.props.disabled && this.foundation.handleBlur();
          }, n.prototype.componentWillUnmount = function () {
            this.foundation && (this.isComponentMounted = !1, this.foundation.destroy());
          }, Object.defineProperty(n.prototype, "classes", {
            get: function get() {
              var t = this.props.className,
                  e = this.state.classList;
              return c.default(Array.from(e), t);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(n.prototype, "style", {
            get: function get() {
              var t = this.props.style,
                  e = this.state.style;
              return Object.assign({}, e, t);
            },
            enumerable: !0,
            configurable: !0
          }), n.prototype.render = function () {
            var e = this.props,
                n = (e.unbounded, e.style, e.className, e.onMouseDown, e.onMouseUp, e.onTouchStart, e.onTouchEnd, e.onKeyDown, e.onKeyUp, e.onFocus, e.onBlur, o(e, ["unbounded", "style", "className", "onMouseDown", "onMouseUp", "onTouchStart", "onTouchEnd", "onKeyDown", "onKeyUp", "onFocus", "onBlur"])),
                i = r({}, n, {
              onMouseDown: this.handleMouseDown,
              onMouseUp: this.handleMouseUp,
              onTouchStart: this.handleTouchStart,
              onTouchEnd: this.handleTouchEnd,
              onKeyDown: this.handleKeyDown,
              onKeyUp: this.handleKeyUp,
              onFocus: this.handleFocus,
              onBlur: this.handleBlur,
              initRipple: this.initializeFoundation,
              className: this.classes,
              style: this.style
            });
            return u.default.createElement(t, r({}, i));
          }, n;
        }(u.default.Component)).defaultProps = r({
          unbounded: !1,
          disabled: !1,
          style: {},
          className: "",
          onMouseDown: function onMouseDown() {},
          onMouseUp: function onMouseUp() {},
          onTouchStart: function onTouchStart() {},
          onTouchEnd: function onTouchEnd() {},
          onKeyDown: function onKeyDown() {},
          onKeyUp: function onKeyUp() {},
          onFocus: function onFocus() {},
          onBlur: function onBlur() {}
        }, t.defaultProps), e;
      };
    },
    108: function _(t, e, n) {
      "use strict";
      /**
       * @license
       * Copyright 2018 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */

      function i(t, e) {
        if (t.closest) return t.closest(e);

        for (var n = t; n;) {
          if (a(n, e)) return n;
          n = n.parentElement;
        }

        return null;
      }

      function a(t, e) {
        return (t.matches || t.webkitMatchesSelector || t.msMatchesSelector).call(t, e);
      }

      n.r(e), n.d(e, "closest", function () {
        return i;
      }), n.d(e, "matches", function () {
        return a;
      });
    },
    155: function _(t, e, n) {
      "use strict";

      n.r(e);
      "function" == typeof Symbol && Symbol.iterator;
      /*! *****************************************************************************
      Copyright (c) Microsoft Corporation. All rights reserved.
      Licensed under the Apache License, Version 2.0 (the "License"); you may not use
      this file except in compliance with the License. You may obtain a copy of the
      License at http://www.apache.org/licenses/LICENSE-2.0
      
      THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
      WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
      MERCHANTABLITY OR NON-INFRINGEMENT.
      
      See the Apache Version 2.0 License for specific language governing permissions
      and limitations under the License.
      ***************************************************************************** */

      var _i2 = function i(t, e) {
        return (_i2 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(t, e);
      };

      var _a = function a() {
        return (_a = Object.assign || function (t) {
          for (var e, n = 1, i = arguments.length; n < i; n++) {
            for (var a in e = arguments[n]) {
              Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
            }
          }

          return t;
        }).apply(this, arguments);
      };
      /**
       * @license
       * Copyright 2016 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */


      var r = function () {
        function t(t) {
          void 0 === t && (t = {}), this.adapter_ = t;
        }

        return Object.defineProperty(t, "cssClasses", {
          get: function get() {
            return {};
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t, "strings", {
          get: function get() {
            return {};
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t, "numbers", {
          get: function get() {
            return {};
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t, "defaultAdapter", {
          get: function get() {
            return {};
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.init = function () {}, t.prototype.destroy = function () {}, t;
      }(),
          o = {
        BG_FOCUSED: "mdc-ripple-upgraded--background-focused",
        FG_ACTIVATION: "mdc-ripple-upgraded--foreground-activation",
        FG_DEACTIVATION: "mdc-ripple-upgraded--foreground-deactivation",
        ROOT: "mdc-ripple-upgraded",
        UNBOUNDED: "mdc-ripple-upgraded--unbounded"
      },
          s = {
        VAR_FG_SCALE: "--mdc-ripple-fg-scale",
        VAR_FG_SIZE: "--mdc-ripple-fg-size",
        VAR_FG_TRANSLATE_END: "--mdc-ripple-fg-translate-end",
        VAR_FG_TRANSLATE_START: "--mdc-ripple-fg-translate-start",
        VAR_LEFT: "--mdc-ripple-left",
        VAR_TOP: "--mdc-ripple-top"
      },
          u = {
        DEACTIVATION_TIMEOUT_MS: 225,
        FG_DEACTIVATION_MS: 150,
        INITIAL_ORIGIN_SCALE: .6,
        PADDING: 10,
        TAP_DELAY_MS: 300
      },
          c = n(38);

      n.d(e, "MDCRippleFoundation", function () {
        return f;
      });
      /**
       * @license
       * Copyright 2016 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */

      var d = ["touchstart", "pointerdown", "mousedown", "keydown"],
          p = ["touchend", "pointerup", "mouseup", "contextmenu"],
          l = [],
          f = function (t) {
        function e(n) {
          var i = t.call(this, _a({}, e.defaultAdapter, n)) || this;
          return i.activationAnimationHasEnded_ = !1, i.activationTimer_ = 0, i.fgDeactivationRemovalTimer_ = 0, i.fgScale_ = "0", i.frame_ = {
            width: 0,
            height: 0
          }, i.initialSize_ = 0, i.layoutFrame_ = 0, i.maxRadius_ = 0, i.unboundedCoords_ = {
            left: 0,
            top: 0
          }, i.activationState_ = i.defaultActivationState_(), i.activationTimerCallback_ = function () {
            i.activationAnimationHasEnded_ = !0, i.runDeactivationUXLogicIfReady_();
          }, i.activateHandler_ = function (t) {
            return i.activate_(t);
          }, i.deactivateHandler_ = function () {
            return i.deactivate_();
          }, i.focusHandler_ = function () {
            return i.handleFocus();
          }, i.blurHandler_ = function () {
            return i.handleBlur();
          }, i.resizeHandler_ = function () {
            return i.layout();
          }, i;
        }

        return function (t, e) {
          function n() {
            this.constructor = t;
          }

          _i2(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
        }(e, t), Object.defineProperty(e, "cssClasses", {
          get: function get() {
            return o;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "strings", {
          get: function get() {
            return s;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "numbers", {
          get: function get() {
            return u;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "defaultAdapter", {
          get: function get() {
            return {
              addClass: function addClass() {},
              browserSupportsCssVars: function browserSupportsCssVars() {
                return !0;
              },
              computeBoundingRect: function computeBoundingRect() {
                return {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                  width: 0,
                  height: 0
                };
              },
              containsEventTarget: function containsEventTarget() {
                return !0;
              },
              deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler() {},
              deregisterInteractionHandler: function deregisterInteractionHandler() {},
              deregisterResizeHandler: function deregisterResizeHandler() {},
              getWindowPageOffset: function getWindowPageOffset() {
                return {
                  x: 0,
                  y: 0
                };
              },
              isSurfaceActive: function isSurfaceActive() {
                return !0;
              },
              isSurfaceDisabled: function isSurfaceDisabled() {
                return !0;
              },
              isUnbounded: function isUnbounded() {
                return !0;
              },
              registerDocumentInteractionHandler: function registerDocumentInteractionHandler() {},
              registerInteractionHandler: function registerInteractionHandler() {},
              registerResizeHandler: function registerResizeHandler() {},
              removeClass: function removeClass() {},
              updateCssVariable: function updateCssVariable() {}
            };
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.init = function () {
          var t = this,
              n = this.supportsPressRipple_();

          if (this.registerRootHandlers_(n), n) {
            var i = e.cssClasses,
                a = i.ROOT,
                r = i.UNBOUNDED;
            requestAnimationFrame(function () {
              t.adapter_.addClass(a), t.adapter_.isUnbounded() && (t.adapter_.addClass(r), t.layoutInternal_());
            });
          }
        }, e.prototype.destroy = function () {
          var t = this;

          if (this.supportsPressRipple_()) {
            this.activationTimer_ && (clearTimeout(this.activationTimer_), this.activationTimer_ = 0, this.adapter_.removeClass(e.cssClasses.FG_ACTIVATION)), this.fgDeactivationRemovalTimer_ && (clearTimeout(this.fgDeactivationRemovalTimer_), this.fgDeactivationRemovalTimer_ = 0, this.adapter_.removeClass(e.cssClasses.FG_DEACTIVATION));
            var n = e.cssClasses,
                i = n.ROOT,
                a = n.UNBOUNDED;
            requestAnimationFrame(function () {
              t.adapter_.removeClass(i), t.adapter_.removeClass(a), t.removeCssVars_();
            });
          }

          this.deregisterRootHandlers_(), this.deregisterDeactivationHandlers_();
        }, e.prototype.activate = function (t) {
          this.activate_(t);
        }, e.prototype.deactivate = function () {
          this.deactivate_();
        }, e.prototype.layout = function () {
          var t = this;
          this.layoutFrame_ && cancelAnimationFrame(this.layoutFrame_), this.layoutFrame_ = requestAnimationFrame(function () {
            t.layoutInternal_(), t.layoutFrame_ = 0;
          });
        }, e.prototype.setUnbounded = function (t) {
          var n = e.cssClasses.UNBOUNDED;
          t ? this.adapter_.addClass(n) : this.adapter_.removeClass(n);
        }, e.prototype.handleFocus = function () {
          var t = this;
          requestAnimationFrame(function () {
            return t.adapter_.addClass(e.cssClasses.BG_FOCUSED);
          });
        }, e.prototype.handleBlur = function () {
          var t = this;
          requestAnimationFrame(function () {
            return t.adapter_.removeClass(e.cssClasses.BG_FOCUSED);
          });
        }, e.prototype.supportsPressRipple_ = function () {
          return this.adapter_.browserSupportsCssVars();
        }, e.prototype.defaultActivationState_ = function () {
          return {
            activationEvent: void 0,
            hasDeactivationUXRun: !1,
            isActivated: !1,
            isProgrammatic: !1,
            wasActivatedByPointer: !1,
            wasElementMadeActive: !1
          };
        }, e.prototype.registerRootHandlers_ = function (t) {
          var e = this;
          t && (d.forEach(function (t) {
            e.adapter_.registerInteractionHandler(t, e.activateHandler_);
          }), this.adapter_.isUnbounded() && this.adapter_.registerResizeHandler(this.resizeHandler_)), this.adapter_.registerInteractionHandler("focus", this.focusHandler_), this.adapter_.registerInteractionHandler("blur", this.blurHandler_);
        }, e.prototype.registerDeactivationHandlers_ = function (t) {
          var e = this;
          "keydown" === t.type ? this.adapter_.registerInteractionHandler("keyup", this.deactivateHandler_) : p.forEach(function (t) {
            e.adapter_.registerDocumentInteractionHandler(t, e.deactivateHandler_);
          });
        }, e.prototype.deregisterRootHandlers_ = function () {
          var t = this;
          d.forEach(function (e) {
            t.adapter_.deregisterInteractionHandler(e, t.activateHandler_);
          }), this.adapter_.deregisterInteractionHandler("focus", this.focusHandler_), this.adapter_.deregisterInteractionHandler("blur", this.blurHandler_), this.adapter_.isUnbounded() && this.adapter_.deregisterResizeHandler(this.resizeHandler_);
        }, e.prototype.deregisterDeactivationHandlers_ = function () {
          var t = this;
          this.adapter_.deregisterInteractionHandler("keyup", this.deactivateHandler_), p.forEach(function (e) {
            t.adapter_.deregisterDocumentInteractionHandler(e, t.deactivateHandler_);
          });
        }, e.prototype.removeCssVars_ = function () {
          var t = this,
              n = e.strings;
          Object.keys(n).forEach(function (e) {
            0 === e.indexOf("VAR_") && t.adapter_.updateCssVariable(n[e], null);
          });
        }, e.prototype.activate_ = function (t) {
          var e = this;

          if (!this.adapter_.isSurfaceDisabled()) {
            var n = this.activationState_;

            if (!n.isActivated) {
              var i = this.previousActivationEvent_;
              if (!(i && void 0 !== t && i.type !== t.type)) n.isActivated = !0, n.isProgrammatic = void 0 === t, n.activationEvent = t, n.wasActivatedByPointer = !n.isProgrammatic && void 0 !== t && ("mousedown" === t.type || "touchstart" === t.type || "pointerdown" === t.type), void 0 !== t && l.length > 0 && l.some(function (t) {
                return e.adapter_.containsEventTarget(t);
              }) ? this.resetActivationState_() : (void 0 !== t && (l.push(t.target), this.registerDeactivationHandlers_(t)), n.wasElementMadeActive = this.checkElementMadeActive_(t), n.wasElementMadeActive && this.animateActivation_(), requestAnimationFrame(function () {
                l = [], n.wasElementMadeActive || void 0 === t || " " !== t.key && 32 !== t.keyCode || (n.wasElementMadeActive = e.checkElementMadeActive_(t), n.wasElementMadeActive && e.animateActivation_()), n.wasElementMadeActive || (e.activationState_ = e.defaultActivationState_());
              }));
            }
          }
        }, e.prototype.checkElementMadeActive_ = function (t) {
          return void 0 === t || "keydown" !== t.type || this.adapter_.isSurfaceActive();
        }, e.prototype.animateActivation_ = function () {
          var t = this,
              n = e.strings,
              i = n.VAR_FG_TRANSLATE_START,
              a = n.VAR_FG_TRANSLATE_END,
              r = e.cssClasses,
              o = r.FG_DEACTIVATION,
              s = r.FG_ACTIVATION,
              u = e.numbers.DEACTIVATION_TIMEOUT_MS;
          this.layoutInternal_();
          var c = "",
              d = "";

          if (!this.adapter_.isUnbounded()) {
            var p = this.getFgTranslationCoordinates_(),
                l = p.startPoint,
                f = p.endPoint;
            c = l.x + "px, " + l.y + "px", d = f.x + "px, " + f.y + "px";
          }

          this.adapter_.updateCssVariable(i, c), this.adapter_.updateCssVariable(a, d), clearTimeout(this.activationTimer_), clearTimeout(this.fgDeactivationRemovalTimer_), this.rmBoundedActivationClasses_(), this.adapter_.removeClass(o), this.adapter_.computeBoundingRect(), this.adapter_.addClass(s), this.activationTimer_ = setTimeout(function () {
            return t.activationTimerCallback_();
          }, u);
        }, e.prototype.getFgTranslationCoordinates_ = function () {
          var t,
              e = this.activationState_,
              n = e.activationEvent;
          return {
            startPoint: t = {
              x: (t = e.wasActivatedByPointer ? Object(c.getNormalizedEventCoords)(n, this.adapter_.getWindowPageOffset(), this.adapter_.computeBoundingRect()) : {
                x: this.frame_.width / 2,
                y: this.frame_.height / 2
              }).x - this.initialSize_ / 2,
              y: t.y - this.initialSize_ / 2
            },
            endPoint: {
              x: this.frame_.width / 2 - this.initialSize_ / 2,
              y: this.frame_.height / 2 - this.initialSize_ / 2
            }
          };
        }, e.prototype.runDeactivationUXLogicIfReady_ = function () {
          var t = this,
              n = e.cssClasses.FG_DEACTIVATION,
              i = this.activationState_,
              a = i.hasDeactivationUXRun,
              r = i.isActivated;
          (a || !r) && this.activationAnimationHasEnded_ && (this.rmBoundedActivationClasses_(), this.adapter_.addClass(n), this.fgDeactivationRemovalTimer_ = setTimeout(function () {
            t.adapter_.removeClass(n);
          }, u.FG_DEACTIVATION_MS));
        }, e.prototype.rmBoundedActivationClasses_ = function () {
          var t = e.cssClasses.FG_ACTIVATION;
          this.adapter_.removeClass(t), this.activationAnimationHasEnded_ = !1, this.adapter_.computeBoundingRect();
        }, e.prototype.resetActivationState_ = function () {
          var t = this;
          this.previousActivationEvent_ = this.activationState_.activationEvent, this.activationState_ = this.defaultActivationState_(), setTimeout(function () {
            return t.previousActivationEvent_ = void 0;
          }, e.numbers.TAP_DELAY_MS);
        }, e.prototype.deactivate_ = function () {
          var t = this,
              e = this.activationState_;

          if (e.isActivated) {
            var n = _a({}, e);

            e.isProgrammatic ? (requestAnimationFrame(function () {
              return t.animateDeactivation_(n);
            }), this.resetActivationState_()) : (this.deregisterDeactivationHandlers_(), requestAnimationFrame(function () {
              t.activationState_.hasDeactivationUXRun = !0, t.animateDeactivation_(n), t.resetActivationState_();
            }));
          }
        }, e.prototype.animateDeactivation_ = function (t) {
          var e = t.wasActivatedByPointer,
              n = t.wasElementMadeActive;
          (e || n) && this.runDeactivationUXLogicIfReady_();
        }, e.prototype.layoutInternal_ = function () {
          var t = this;
          this.frame_ = this.adapter_.computeBoundingRect();
          var n = Math.max(this.frame_.height, this.frame_.width);
          this.maxRadius_ = this.adapter_.isUnbounded() ? n : Math.sqrt(Math.pow(t.frame_.width, 2) + Math.pow(t.frame_.height, 2)) + e.numbers.PADDING, this.initialSize_ = Math.floor(n * e.numbers.INITIAL_ORIGIN_SCALE), this.fgScale_ = "" + this.maxRadius_ / this.initialSize_, this.updateLayoutCssVars_();
        }, e.prototype.updateLayoutCssVars_ = function () {
          var t = e.strings,
              n = t.VAR_FG_SIZE,
              i = t.VAR_LEFT,
              a = t.VAR_TOP,
              r = t.VAR_FG_SCALE;
          this.adapter_.updateCssVariable(n, this.initialSize_ + "px"), this.adapter_.updateCssVariable(r, this.fgScale_), this.adapter_.isUnbounded() && (this.unboundedCoords_ = {
            left: Math.round(this.frame_.width / 2 - this.initialSize_ / 2),
            top: Math.round(this.frame_.height / 2 - this.initialSize_ / 2)
          }, this.adapter_.updateCssVariable(i, this.unboundedCoords_.left + "px"), this.adapter_.updateCssVariable(a, this.unboundedCoords_.top + "px"));
        }, e;
      }(r);

      e.default = f;
    },
    38: function _(t, e, n) {
      "use strict";

      var i, a;

      function r(t, e) {
        void 0 === e && (e = !1);
        var n = t.CSS,
            a = i;
        if ("boolean" == typeof i && !e) return i;
        if (!(n && "function" == typeof n.supports)) return !1;
        var r = n.supports("--css-vars", "yes"),
            o = n.supports("(--css-vars: yes)") && n.supports("color", "#00000000");
        return a = !(!r && !o) && !function (t) {
          var e = t.document,
              n = e.createElement("div");
          n.className = "mdc-ripple-surface--test-edge-var-bug", e.body.appendChild(n);
          var i = t.getComputedStyle(n),
              a = null !== i && "solid" === i.borderTopStyle;
          return n.remove(), a;
        }(t), e || (i = a), a;
      }

      function o(t, e) {
        if (void 0 === t && (t = window), void 0 === e && (e = !1), void 0 === a || e) {
          var n = !1;

          try {
            t.document.addEventListener("test", function () {}, {
              get passive() {
                return n = !0;
              }

            });
          } catch (t) {}

          a = n;
        }

        return !!a && {
          passive: !0
        };
      }

      function s(t, e, n) {
        if (!t) return {
          x: 0,
          y: 0
        };
        var i,
            a,
            r = e.x,
            o = e.y,
            s = r + n.left,
            u = o + n.top;

        if ("touchstart" === t.type) {
          var c = t;
          i = c.changedTouches[0].pageX - s, a = c.changedTouches[0].pageY - u;
        } else {
          var d = t;
          i = d.pageX - s, a = d.pageY - u;
        }

        return {
          x: i,
          y: a
        };
      }

      n.r(e), n.d(e, "supportsCssVariables", function () {
        return r;
      }), n.d(e, "applyPassive", function () {
        return o;
      }), n.d(e, "getNormalizedEventCoords", function () {
        return s;
      });
    }
  });
});